module.exports = __webpack_public_path__ + "media/images/athletes/1659-0e329658c2c33da2417e2c4eabb7e5bb.png";